import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  Filters,
  FnCaricamentoDati,
  SortBy,
} from 'src/app/components/lista-tabellare/classes/lista-tabellare-data-source';
import { Colonna } from 'src/app/components/lista-tabellare/lista-tabellare.component';
import {
  Attivazione,
  PacchettoAggiuntivoAttivazione,
} from 'src/app/services/licenze/licenze.service';
import { UtilityService } from 'src/app/services/utility/utility.service';

@Component({
  selector: 'app-dialog-pacchetti-aggiuntivi',
  templateUrl: './dialog-pacchetti-aggiuntivi.component.html',
  styleUrls: ['./dialog-pacchetti-aggiuntivi.component.scss'],
  standalone: false,
})
export class DialogPacchettiAggiuntiviComponent {
  public generalita = '';

  public colonne: { [key: string]: Colonna } = {
    dataAttivazione: {
      title: 'Data attivazione',
      sortable: true,
      value: (record: PacchettoAggiuntivoAttivazione) => this.formattaData(record?.dataAttivazione),
    },
    dataScadenza: {
      title: 'Data scadenza',
      sortable: true,
      value: (record: PacchettoAggiuntivoAttivazione) => this.formattaData(record?.dataScadenza),
    },
    acquisti: {
      title: 'Acquisti',
      sortable: false,
      value: (record: PacchettoAggiuntivoAttivazione) => this.formattaAcquisti(record?.acquisti),
    },
  };

  constructor(
    public dialogRef: MatDialogRef<DialogPacchettiAggiuntiviComponent>,
    private readonly utilityService: UtilityService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      attivazione: Attivazione;
    },
  ) {
    const attivazione = this.data?.attivazione;

    this.generalita = [attivazione?.cognome, attivazione?.nome]
      .filter((val) => !!val)
      .join(' ')
      .trim();

    if (!this.generalita) {
      this.generalita = attivazione?.emailAttivazione || attivazione?.keyId || '';
    }
  }

  public fnCaricamentoDati: FnCaricamentoDati = (
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ) => {
    return this.utilityService.getDatiTableArray(
      this.data?.attivazione?.pacchettiAggiuntivi || [],
      ['codicePacchetto'],
      ricerca,
      page,
      pageSize,
      sortBy,
    );
  };

  /**
   * Le date arrivano dal backend nel formato yyyy-MM-dd
   */
  private formattaData(data?: string): string {
    if (!data) {
      return '-';
    }

    const dataConvertita = new Date(data);

    return isNaN(dataConvertita.getTime()) ? data : dataConvertita.toLocaleDateString('it-IT');
  }

  private formattaAcquisti(acquisti?: { [tipo: string]: number }): string {
    if (!acquisti) {
      return '-';
    }

    const valori = Object.keys(acquisti)
      .filter((tipo) => !!acquisti[tipo])
      .map((tipo) => tipo + ': ' + acquisti[tipo]);

    return valori.length ? valori.join(' • ') : '-';
  }
}
